import React from 'react';
import { Drawer, Typography, Flex } from 'antd';
import CodeInput from 'shared/ui/CodeInput/CodeInput';
import { useIntl } from 'react-intl';
import { CopyIcon } from 'shared/ui';

interface PinDrawerProps {
  open: boolean;
  onClose: () => void;
  isTwoFactorEnabled: boolean;
  pin: string | null;
  codeInputRef: React.RefObject<any>;
  handleCodeSubmit: (code: string) => void;
  handleCodeResend: () => void;
}

const PinDrawer: React.FC<PinDrawerProps> = ({
  open,
  onClose,
  isTwoFactorEnabled,
  pin,
  codeInputRef,
  handleCodeSubmit,
  handleCodeResend,
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <Drawer
      title={t({ id: 'card.cardRules.getPin' })}
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
      styles={{
        header: {
          borderBottom: 'none',
        },
        body: {
          padding: 24,
        },
      }}
    >
      <div style={{ width: '100%' }}>
        {pin ? (
          <Flex align="center" justify="center">
            <Typography.Title
              level={1}
              style={{
                textAlign: 'center',
                marginBottom: 0,
                marginTop: 0,
              }}
            >
              {pin}
            </Typography.Title>
            <CopyIcon value={pin} />
          </Flex>
        ) : (
          <>
            <Typography.Paragraph style={{ textAlign: 'center' }}>
              {isTwoFactorEnabled
                ? t({ id: 'code.2fa.enter' })
                : t({ id: 'code.sms.enter' })}
            </Typography.Paragraph>

            <CodeInput
              ref={codeInputRef}
              onEnter={handleCodeSubmit}
              onResend={handleCodeResend}
              timeout={60}
              isPhone
            />
          </>
        )}
      </div>
    </Drawer>
  );
};

export default PinDrawer;
